import { z } from 'zod';

import { careerTrackSchema } from './career-track';
import { simplePaginationSchema } from './pagination';

export const levelingFrameworkSchema = z.object({
    id: z.uuid(),
    createdAt: z.iso.datetime(),
    description: z.string(),
    editable: z.boolean(),
    lastUpdate: z.iso.datetime(),
    name: z.string(),
    tracks: careerTrackSchema.array(),
    type: z.enum(['MARKET', 'UNION', 'CUSTOM']),
});

export type LevelingFramework = z.infer<typeof levelingFrameworkSchema>;

export const paginatedLevelingFrameworkSchema = z.object({
    data: levelingFrameworkSchema.array(),
    pagination: simplePaginationSchema,
});

export type PaginatedLevelingFramework = z.infer<typeof paginatedLevelingFrameworkSchema>;
